<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null">
        <v-card-title><span class="headline">Dodawanie vouchera</span></v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Imię i nazwisko"
                  v-model="formData.name"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="getVouchersTypeList"
                  label="Nazwa vouchera"
                  data-vv-name="nazwa vouchera"
                  v-model="formData.type_id"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors.collect('nazwa vouchera')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Numer faktury/paragonu"
                  v-model="formData.invoice_number"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                label="Wartość"
                v-validate="'required'"
                type="number"
                step="0.01"
                v-model="formData.price"
                data-vv-name="wartość"
                :error-messages="errors.collect('wartość')"
                browser-autocomplete="off">
              </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                  label="Pokaż cenę vouchera"
                  v-model="formData.show_price"
                  browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                  label="Faktura do vouchera"
                  v-model="formData.has_invoice"
                  browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="Voucher ze strony internetowej"
                  v-model="formData.from_internet"
                  @change="onChangeFromInternet"
                  browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-if="formData.from_internet"
                  label="Numer vouchera"
                  v-validate="'required'"
                  v-model="formData.voucher_number"
                  data-vv-name="numer vouchera"
                  :error-messages="errors.collect('numer vouchera')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-menu
                  :close-on-content-click="false"
                  v-model="addVoucherDatePicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    label="Data wygaśnięcia"
                    v-validate="'required'"
                    slot="activator"
                    v-model="formData.expired_at"
                    data-vv-name="data wygaśnięcia"
                    :error-messages="errors.collect('data wygaśnięcia')"
                    readonly
                    browser-autocomplete="off">
                  </v-text-field>
                  <v-date-picker v-validate="'required'"
                                 v-model="formData.expired_at"
                                 data-vv-name="data wygaśnięcia"
                                 :error-messages="errors.collect('data wygaśnięcia')"
                                 @input="addVoucherDatePicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Opis usługi"
                  box
                  text-area
                  v-validate="'required|max:159'"
                  counter="159"
                  v-model="formData.service_type"
                  data-vv-name="opis usługi"
                  :error-messages="errors.collect('opis usługi')"
                  browser-autocomplete="off">
                </v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Notatka wewnętrzna"
                  box
                  text-area
                  v-model="formData.internal_note"
                  data-vv-name="opis usługi"
                  :error-messages="errors.collect('notatka wewnętrzna')"
                  browser-autocomplete="off">
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$router.push({name: 'Vouchers'})">Anuluj</v-btn>
          <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {clearEmptyFields} from '../../helpers/clearEmptyFields';

  export default {
    name: 'CreateVoucher',
    data() {
      return {
        open: true,
        formData: {
          show_price: true,
          has_invoice: false,
        },
        isProcessing: false,
        addVoucherDatePicker: false,
        addVoucherDate: new Date().toISOString()
          .substr(0, 10),
      };
    },
    computed: {
      ...mapGetters('VoucherTypeStore', ['getVouchersTypeList']),
    },
    methods: {
      ...mapActions('VoucherStore', ['createVoucher']),
      onChangeFromInternet(val) {
        if (!val) {
          this.formData.voucher_number = '';
        }
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              const formData = clearEmptyFields(Object.assign({}, this.formData));
              this.createVoucher(formData)
                .then(() => {
                  this.isProcessing = false;
                  this.formData = {};
                  this.$router.push({name: 'Vouchers'});
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
